import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import { saveAsPDF } from './util/pdf/saveAsPdf';
import { useLoadingWorksheetPreviewContext, useWorksheetAccessContext, useWorksheetSettingContext } from './context';
export const QuizWorksheetModalAction = ({
  onCancel,
  onConfirm,
  onSaveSuccess,
  onSaveFail,
  className
}: {
  onCancel: () => void;
  onConfirm: () => void;
  onSaveSuccess: () => void;
  onSaveFail: () => void;
  className?: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isLoading
  } = useLoadingWorksheetPreviewContext();
  const {
    isPro
  } = useWorksheetAccessContext();
  const {
    worksheetTitle,
    worksheetTeacherName,
    shouldIncludeAnswerPage,
    additionalSetting
  } = useWorksheetSettingContext();
  const [isSaving, setIsSaving] = useState(false);
  const isDisabled = isLoading || isSaving;
  const handleSaveWorksheet = async ({
    onSuccess,
    onFail
  }: {
    onSuccess: () => void;
    onFail: () => void;
  }) => {
    if (!isPro) {
      onFail();
      return;
    }
    //NOTE: 파일 저장 시작 시간
    const saveStartTime = new Date();
    onConfirm();
    setIsSaving(true);
    const savedPDFBlob = await saveAsPDF();
    //NOTE: 파일 저장 종료 시간
    //파일 저장 시 걸린 시간 logging
    const saveEndTime = new Date();
    const saveDuration = (saveEndTime.getTime() - saveStartTime.getTime()) / 1000;
    logger.track('quiz_worksheet_save', {
      saveDuration,
      pdf_size_in_mb: (savedPDFBlob.size / (1024 * 1024)).toFixed(2),
      pdf_title: worksheetTitle,
      pdf_teacher_name: worksheetTeacherName,
      include_answer_page: shouldIncludeAnswerPage,
      include_entry_code: additionalSetting.addJoinCode,
      random_question_order: additionalSetting.randomQuestionOrder,
      random_choice_order: additionalSetting.randomChoiceOrder
    });
    onSuccess();
  };
  return <div className={cn('flex w-full flex-row justify-end gap-xs', className)} data-sentry-component="QuizWorksheetModalAction" data-sentry-source-file="QuizWorksheetModalAction.tsx">
      <Button variant="transparent" intent="neutral" size={'lg'} onClick={onCancel} disabled={isDisabled} data-sentry-element="Button" data-sentry-source-file="QuizWorksheetModalAction.tsx">
        {t('common:global.cancel.button')}
      </Button>
      <Button className="max-mobile-lg:grow" variant="contained" intent="strong" size="lg" disabled={isDisabled} onClick={() => {
      void handleSaveWorksheet({
        onSuccess: onSaveSuccess,
        onFail: onSaveFail
      });
    }} data-sentry-element="Button" data-sentry-source-file="QuizWorksheetModalAction.tsx">
        {isPro ? t('common:quizWorksheet.saveAsPdf') : t('common:quizWorksheet.saveAsPdfPro')}
      </Button>
    </div>;
};